const pokedex = {
    miles: {
        key: 'miles',
        name: 'Miles',
        evolvesInto: 'kilometers',
        cp: 944,
        portrait: 'images/miles.png',
        stats: {
            age: '32',
            type: 'fire',
            role: 'Old Boy'
        },
        description: 'Mileses are usually found in front of computers at Security Labs, LLC, listening to podcasts or the Hamilton soundtrack. This Rauschémon programs websites and is never far from coffee. He keeps buff by visiting the gym regularly and then going straight home without changing.',
        catch: {
            location: 'Aberdeen, SD, United States',
            date: '2/28/1983'
        }
    },
    kilometers: {
        key: 'kilometers',
        name: 'Kilometers',
        evolvesInto: '',
        cp: 2098,
        portrait: 'images/kilometers.png',
        stats: {
            age: '33',
            type: 'fire',
            role: 'Old Boy'
        },
        description: 'Like Mileses, Kilometers spend a lot of time in front of computers but only come out during the night. This Rauschémon completed the NaNoWriMo challenge in November and spent most of the rest of the year whining about not having time to write. When the creative pressure is too much, Kilometers can be seen playing Pokémon Go.',
        catch: {
            location: 'Aberdeen, SD, United States',
            date: '2/28/1983'
        }
    },
    holli: {
        key: 'holli',
        name: 'Holli',
        evolvesInto: 'holliweather',
        cp: 844,
        portrait: 'images/holli.png',
        stats: {
            age: '29',
            type: 'electric',
            role: 'Old Girl'
        },
        description: 'Hollis can be found wandering the halls of New Tech High School teaching art and photography. In the fall, you may spot this Rauschémon in a festive homecoming costume. Hollis are great cooks and bakers and enjoy fancy scarves.',
        catch: {
            location: 'Hawarden, SD, United States',
            date: '4/15/1986'
        }
    },
    holliweather: {
        key: 'holliweather',
        name: 'Holliweather',
        evolvesInto: '',
        cp: 1984,
        portrait: 'images/holliweather.png',
        stats: {
            age: '30',
            type: 'electric',
            role: 'Old Girl'
        },
        description: 'Holliweathers are creators. They sometimes etch designs onto glassware or print designs onto shirts. This Rauschémon carries around small objects created by a mysterious and magical device called a 3-D printer. When given some quiet time alone, this Rauschémon might be discovered coloring in zen-like tranquility.',
        catch: {
            location: 'Hawarden, SD, United States',
            date: '4/15/1986'
        }
    },
    ian: {
        key: 'ian',
        name: 'Ian',
        evolvesInto: 'ianblastoise',
        cp: 612,
        portrait: 'images/ian.png',
        stats: {
            age: '5',
            type: 'water',
            role: 'Boy'
        },
        description: 'Ians are fans of summer camp, especially Star Wars camp and Lake Okoboji Methodist Camp (with a friendly Holliweather). They love to run and often reach speeds of up to 750 miles per hour. Ians live mostly off hot chili soup and tator tot casserole.',
        catch: {
            location: 'Sioux Falls, SD, United States',
            date: '4/30/2010'
        }
    },
    ianblastoise: {
        key: 'ianblastoise',
        name: 'BuDian-Blastoise',
        evolvesInto: '',
        cp: 1450,
        portrait: 'images/ianblastoise.png',
        stats: {
            age: '6',
            type: 'water',
            role: 'Boy'
        },
        description: 'BuDian-Blastoise look like Ians but are missing four teeth (including the front two). They can be found on the playground at St. Lambert School where they attend kindergarten. This Rauschémon enjoys taekwondo and currently has a yellow belt. They can be spotted learning to read words like: "red", "seven" and "love."',
        catch: {
            location: 'Sioux Falls, SD, United States',
            date: '4/30/2010'
        }
    },
    ainsley: {
        key: 'ainsley',
        name: 'Ainsley',
        evolvesInto: 'ellie',
        cp: 445,
        portrait: 'images/ainsley.png',
        stats: {
            age: '3',
            type: 'flying',
            role: 'Girl'
        },
        description: 'Ainsleys enjoy summer camps, too, just like Ians. This Rauschémon loves to dance at dance class or whenever they feel the music. Ainsleys eat cheese almost exclusively which sometimes results in chest x-rays and severe constipation.',
        catch: {
            location: 'Sioux Falls, SD, United States',
            date: '9/23/2012'
        }
    },
    ellie: {
        key: 'ellie',
        name: 'Ellie',
        evolvesInto: '',
        cp: 1409,
        portrait: 'images/ellie.png',
        stats: {
            age: '4',
            type: 'flying',
            role: 'Girl'
        },
        description: 'Ellies can be found at St. Lambert preschool playing dress up and house. This Rauschémon can write her name and enjoys giving warm hugs. Ellies can be found wandering around in costumes and shoes that don\'t belong to them.',
        catch: {
            location: 'Sioux Falls, SD, United States',
            date: '9/23/2012'
        }
    }
};

export default pokedex;



/** WEBPACK FOOTER **
 ** ./src/_pokedex.js
 **/